import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    rotation: 0,
    scaleX:0,
    scaleY:0
};

const pixiObjectProperties = createSlice({
    name: 'objectProperties',
    initialState,
    reducers: {
        setObjectProperties: (state, action) => {
            state.x = action.payload.x;
            state.y = action.payload.y;
            state.width = action.payload.width;
            state.height = action.payload.height;
            state.rotation = action.payload.rotation;
        },
        updateObjectProperty: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
});

export const { setObjectProperties, updateObjectProperty } = pixiObjectProperties.actions;

export default pixiObjectProperties.reducer;
